export default __webpack_public_path__ + "static/media/KOD0051-min.bcbc49a4.webp";